import React from 'react';
import vdo1 from '../../../../video/photography/gazi ditf.mp4';
import vdo2 from '../../../../video/photography/Womens Day Special Gazi Group.mp4';
import vdo3 from '../../../../video/photography/boatman reel.mp4';
import vdo4 from '../../../../video/photography/burger king.mp4';
import './Photography.css';

const Photography = () => {
    return (
        <section className='photo-section'>
            <div className='photo-header'>
            </div>
            <div className='mt-8'>
                <h1 className='photo-h1'>Our Videography</h1>
                <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 m-8'>
                    <video autoPlay loop controls>
                        <source src={vdo1} type='video/mp4' />
                    </video>
                    <video autoPlay loop controls>
                        <source src={vdo2} type='video/mp4' />
                    </video>
                    <video autoPlay loop controls>
                        <source src={vdo3} type='video/mp4' />
                    </video>
                    <video autoPlay loop controls>
                        <source src={vdo4} type='video/mp4' />
                    </video>
                </div>
            </div>
        </section>
    );
};

export default Photography;